import React from 'react';

import { ReactComponent as DocumentPdfSVG } from './document-pdf.svg';

export const PdfDoc: React.FC = (props) => <DocumentPdfSVG {...props} />;
